<template>
  <ol>
    <li v-bind:key='crumb.url' v-for='crumb in crumbsLinks'>
      <router-link :to='crumb.url'>{{crumb.name}}</router-link>
    </li>
  </ol>
</template>

<script>
import {categoryData} from '@/categories'

export default {
  name: 'Breadcrumb',
  computed: {
    crumbsLinks: function () {
      let crumbs = []
      let path = this.$route.path
      while (true) {
        crumbs.unshift({name: categoryData[path].name, url: path})
        if (path === '/') break
        path = path.substr(0, path.lastIndexOf('/', path.length - 2) + 1)
      }
      return crumbs
    }
  }
}
</script>

<style scoped>
ol {
  display: flex;
  flex-wrap: wrap;
  padding: 0.75rem 1rem;
  margin-bottom: 1rem;
  list-style: none;
  background-color: #f8dbdd;
  border-radius: 0.25rem;
}

li+li:before {
    display: inline-block;
    padding-right: 0.5rem;
    padding-left: 0.5em;
    content: "/";
}
</style>



// WEBPACK FOOTER //
// src/components/Breadcrumb.vue